/**
 * Formats a card brand for display, capitalizing the first letter and
 * lowercasing the rest, so both `VISA` and `visa` render as `Visa`.
 *
 * The backend casing is inconsistent across endpoints (uppercase in the
 * confirm-session response, lowercase in the block detail), so the first letter
 * is always uppercased to render a stable `Visa`, `Mastercard`. Returns an empty
 * string when the brand is missing.
 *
 * @param brand - Raw card brand from the payment method (null for SPEI)
 * @returns The brand with only its first letter capitalized, or an empty string
 */
export const formatBrand = (brand: string | null): string =>
  brand ? `${brand.charAt(0).toUpperCase()}${brand.slice(1).toLowerCase()}` : '';
